import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { initializeIcons } from '@fluentui/react';
import App from './components/App';

// Initialize Fluent UI icons
initializeIcons();

// Office.onReady must be called before rendering
Office.onReady((info) => {
  if (info.host === Office.HostType.Outlook) {
    const rootElement = document.getElementById('root');
    if (rootElement) {
      const root = ReactDOM.createRoot(rootElement);
      root.render(
        <React.StrictMode>
          <App />
        </React.StrictMode>
      );
    }
  }
});
